// 特惠活动页面接口
import {get,post} from '../utils/request.js'

//获取广告
export const apiGetAdvert = function (data) {
  return get('activity/getAdvert', data);
}

//获取广告
export const apiGetList = function (data) {
  return get('activity/getList', data);
}



// WEBPACK FOOTER //
// ./src/api/activity.js